/**
 * AsterAI / ChainAI Command Center page.
 *
 * Renders the chat panel inside a simple layout shell. The product is
 * inferred from the host: admin.chain29.com / *.asterpos.com → ASTERPOS,
 * everything else → CHAIN29. Override via `?product=ASTERPOS|CHAIN29`.
 */
import React, { useMemo } from 'react';
import AiChatPanel from '@/components/ai/AiChatPanel';
import { AIProduct } from '@/api/aiApi';

function inferProduct() {
  try {
    const params = new URLSearchParams(window.location.search);
    const explicit = params.get('product');
    if (explicit && Object.values(AIProduct).includes(explicit.toUpperCase())) {
      return explicit.toUpperCase();
    }
    const host = window.location.hostname || '';
    if (host.includes('asterpos')) return AIProduct.ASTERPOS;
    return AIProduct.CHAIN29;
  } catch {
    return AIProduct.CHAIN29;
  }
}

export default function AsterAICommandCenter() {
  const product = useMemo(() => inferProduct(), []);
  const productName = product === AIProduct.CHAIN29 ? 'ChainAI' : 'AsterAI';
  return (
    <div
      className="mx-auto flex h-[calc(100vh-64px)] max-w-5xl flex-col gap-4 px-4 py-6"
      data-testid="aster-ai-command-center"
    >
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          {productName} Command Center
        </h1>
        <p className="text-sm text-zinc-500">
          Ask your business AI anything. Read-only in Phase 1 — no actions are
          executed, only data is returned.
        </p>
      </div>
      <div className="flex-1">
        <AiChatPanel product={product} />
      </div>
    </div>
  );
}
